// extracted by mini-css-extract-plugin
export default {"imageContainer":"FavoriteDiagnosisSearchItem_imageContainer__mEQt6","image":"FavoriteDiagnosisSearchItem_image__9sOFe","description":"FavoriteDiagnosisSearchItem_description__ap9n8"};